document.querySelectorAll('.js-accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
        if (window.innerWidth > 840) return;
        const parent = trigger.closest('.js-accordion');
        parent.classList.toggle('is-open');
    });
});